import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from "react";
import { Icon } from "./Icon.js";
import { isLoadError } from "./reload.js";
import { TextsContext } from "./texts.js";
/**
 * Catches an error while a page renders and shows what happened instead of
 * a white page. resetKey (e.g. the route) clears the error when the user
 * goes to another page. homeHref: target of the start page link.
 */
export class ErrorBoundary extends Component {
    static contextType = TextsContext;
    state = { error: null };
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error, info) {
        console.error("page error", error, info.componentStack);
    }
    componentDidUpdate(prev) {
        if (this.state.error && prev.resetKey !== this.props.resetKey)
            this.setState({ error: null });
    }
    render() {
        const { error } = this.state;
        if (!error)
            return this.props.children;
        const t = this.context;
        const load = isLoadError(error);
        const message = error instanceof Error ? error.message : String(error);
        return (_jsx("div", { role: "alert", className: this.props.full ? "flex min-h-screen items-center justify-center p-6" : "flex flex-1 items-center justify-center p-6", children: _jsxs("div", { className: "max-w-md rounded-[20px] bg-surface p-6 text-sm text-fg shadow-panel", children: [_jsxs("div", { className: "flex items-center gap-2", children: [_jsx(Icon, { name: "alert", size: 18, className: "text-warn-fg" }), _jsx("h1", { className: "text-base font-semibold", children: load ? t.loadErrorTitle : t.renderErrorTitle })] }), _jsx("p", { className: "mt-2 text-fg-3", children: load ? t.loadErrorText : t.renderErrorText }), _jsxs("div", { className: "mt-4 flex flex-wrap gap-2", children: [_jsxs("button", { type: "button", onClick: () => window.location.reload(), className: "inline-flex h-9 items-center gap-1.5 rounded-full bg-brand px-4 text-sm font-medium text-on-brand hover:bg-brand-bright focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:outline-none", children: [_jsx(Icon, { name: "refresh", size: 14 }), t.reload] }), _jsx("a", { href: this.props.homeHref ?? "/", className: "inline-flex h-9 items-center rounded-full px-4 text-sm font-medium text-fg-2 ring-1 ring-line hover:bg-hover focus-visible:ring-2 focus-visible:ring-accent focus-visible:outline-none", children: t.home })] }), !load && (_jsxs("details", { className: "mt-3 text-xs text-muted", children: [_jsx("summary", { className: "cursor-pointer", children: t.technicalDetail }), _jsx("p", { className: "mt-1 font-mono [overflow-wrap:anywhere]", children: message })] }))] }) }));
    }
}
